import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { makeStyles } from '@mui/styles';
import { selectSessionId } from '../../redux/features/sessionBoundary/sessionBoundary.selectors';

const useStyles = makeStyles(() => ({
  container: {
    minWidth: '48px',
    margin: '4px !important',
    textAlign: 'center',
  },
}));

// This component will show the duration of the active session
export const Timer = () => {
  const classes = useStyles();
  const sessionId = useAppSelector(selectSessionId);
  const [duration, setDuration] = useState(0);

  const getFormatedDuration = () => {
    const minutes = Math.floor(duration / 60);
    const seconds = duration - minutes * 60;
    const secondsToString =
      seconds > 9 ? String(seconds) : '0' + String(seconds);
    return String(minutes) + ':' + secondsToString;
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (sessionId) {
      const startTime = new Date().getTime() / 1000; // Get start time in seconds
      const getDuration = () => {
        const currentTime = new Date().getTime() / 1000;
        const durationInSecond = Math.floor(currentTime - startTime);
        setDuration(durationInSecond);
      };
      timer = setInterval(() => {
        getDuration();
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
        setDuration(0);
      }
    };
  }, [sessionId]);

  return <div className={classes.container}>{getFormatedDuration()}</div>;
};
